/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';

import { BrandColors, MaterialIcon, PopoverList, Typography } from '@blend/enterprise-components';
import { fonts } from '@blend/consumer-components';
import { logoutUrl } from '../../../common/authAPI';
import { State } from '../../../redux';
import { getConfig } from '@utils/configs';

export namespace NotaryPopoverMenu {
  export interface Props {}
}

export const styles = StyleSheet.create({
  wrapper: {
    ...Typography.Roboto,
    fontWeight: Typography.MEDIUM,
    backgroundColor: BrandColors.NIGHT_90,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: 20,
  },
  logoWrapper: {
    display: 'block',
    width: '50%',
  },
  navButtonsWrapper: {
    marginTop: 64,
  },
  notaryMenuButton: {
    border: 'none',
    background: 'none',
    boxShadow: 'none',
    color: BrandColors.WHITE,
    display: 'flex',
    alignItems: 'center',
    ...fonts.UntitledSans,
  },
  notaryName: {
    marginLeft: 18,
  },
});

export const NotaryPopoverMenu: React.FC<NotaryPopoverMenu.Props> = ({}) => {
  const notaryName = useSelector((state: State) => state.user.fullName);

  const popoverListButtonConfigs = [
    {
      label: 'Manage account',
      onClick: () => {
        window.location.href = `${getConfig().blendBridge.url}/profile`;
      },
    },
    {
      label: 'Sign Out',
      onClick: () => {
        window.location.href = logoutUrl;
      },
    },
  ];

  return (
    <div data-it="NotaryPopoverMenu">
      <PopoverList anchorPosition={'top-start'} buttonConfigs={popoverListButtonConfigs} btnSize={'md'}>
        <button data-it="NotaryPopoverButton" className={css(styles.notaryMenuButton)}>
          <MaterialIcon type={'mood'} size={30} color={BrandColors.WHITE} />
          <span className={css(styles.notaryName)}>{notaryName}</span>
        </button>
      </PopoverList>
    </div>
  );
};
